module.exports = __webpack_public_path__ + "img/Nippon Gases  logo.18cc567f.jpg";